import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import warning from 'warning';
import chainCallbacks from '../utils/chainCallbacks';
import classnames from 'classnames';
import BiDiv from '../biLogger/Components/BiDiv';
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var _a = _this.props, onSelect = _a.onSelect, value = _a.value, label = _a.label, disabled = _a.disabled, children = _a.children;
            if (disabled) {
                event.preventDefault();
                return;
            }
            if (onSelect) {
                var selectedLabel = label;
                if (selectedLabel === undefined) {
                    if (typeof children === 'string') {
                        selectedLabel = children;
                    }
                    else if (value === undefined) {
                        warning(false, '<MenuItem> component must have a `value` attribute, or its children should be plain text.');
                    }
                }
                var selectedValue = void 0;
                if (value !== undefined) {
                    selectedValue = value;
                }
                else {
                    selectedValue = selectedLabel;
                }
                onSelect(selectedValue, selectedLabel);
            }
        };
        return _this;
    }
    MenuItem.prototype.render = function () {
        var _a = this.props, children = _a.children, componentClass = _a.componentClass, componentType = _a.componentType, componentProps = _a.componentProps, className = _a.className, selected = _a.selected, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, dataHook = _a.dataHook, biData = _a.biData, props = __rest(_a, ["children", "componentClass", "componentType", "componentProps", "className", "selected", "onClick", "onMouseEnter", "dataHook", "biData"]);
        // This is necessary to ensure the compiler that the componentClass will not be empty even though it's optional
        var Component = componentClass || MenuItem.defaultProps.componentClass;
        // you cannot set the selected attribute on non option-elements, so we set a custom data-selected attribute to target with css
        var selectedProps;
        if (selected) {
            selectedProps = { 'data-selected': 'selected', selected: selected };
        }
        return (React.createElement(Component, __assign({}, props, componentProps, selectedProps, { className: classnames(componentProps && componentProps.className, className), onClick: chainCallbacks(onClick, this.handleClick), onMouseEnter: onMouseEnter, "data-hook": dataHook, biData: componentProps && componentProps.biData
                ? componentProps.biData
                : biData }), children));
    };
    MenuItem.defaultProps = {
        componentType: MenuItem,
        componentClass: BiDiv,
    };
    return MenuItem;
}(React.Component));
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map